<template>
  <div>
    <input-field v-model="data.name" label="接口名称" :disabled="!editable"></input-field>
    <fields v-model="data.args" :fields="interfaceFields" :disabled="!editable"></fields>
    <submit-field @click="submit" :disabled="!editable || !isValid">确定</submit-field>
  </div>
</template>

<script>
  /** defaults example:
   * {
   *   name: 'uart0',
   *   type: 'RS232',
   *   parameters: [
   *     {
   *       key: 'port',
   *       label: '设备 ID',
   *       type: 'string'
   *     }
   *   ],
   *   args: {
   *     port: '#uart-1'
   *   }
   * }
   */
  import InputField from '@/components/utils/input-field'
  import Fields from '@/components/utils/fields'
  import SubmitField from '@/components/utils/submit-field'

  export default {
    props: {
      defaults: {
        required: false,
        default: Object.create(null),
        type: Object
      },
      event: {
        required: false,
        default: 'interface',
        type: String
      },
      editable: {
        required: false,
        default: true,
        type: Boolean
      }
    },
    data () {
      return {
        data: {
          name: '',
          type: '',
          args: {}
        }
      }
    },
    components: {
      Fields,
      InputField,
      SubmitField
    },
    methods: {
      refresh () {
        this.$set(this.data, 'name', this.defaults.name)
        this.$set(this.data, 'type', this.defaults.type)

        Object.keys(this.data.args).forEach(key => this.$delete(this.data.args, key))

        for (let [key, value] of Object.entries(this.defaults.args)) {
          this.$set(this.data.args, key, value)
        }
      },
      type2Field (type) {
        let map = {
          string: 'input-field',
          number: 'number-field',
          select: 'select-field'
        }

        return map[type]
      },
      submit () {
        let data = { _id: this.defaults._id }

        data.name = this.data.name
        data.type = this.data.type
        data.args = this.defaults.parameters.reduce((acc, value) => {
          let key = value.key

          acc[key] = this.data.args[key]

          return acc
        }, Object.create(null))

        this.$emitter.emit(this.event, data)

        this.$emitter.once(`${this.event}Resp`, err => {
          if (!err) {
            this.editable = false
          }
        })
      }
    },
    created () {
      this.refresh()
    },
    computed: {
      interfaceFields () {
        let fields = []

        for (let parameter of this.defaults.parameters) {
          let field = {
            name: parameter.key,
            field: this.type2Field(parameter.type),
            props: {
              label: parameter.label
            }
          }

          if (parameter.type === 'select') {
            field.props.list = parameter.options
          }

          fields.push(field)
        }

        return fields
      },
      isValid () {
        // return this.data.name && this.data.type && this.interfaceFields.every(iface => !!this.data.args[iface.name])
        return true
      }
    },
    watch: {
      defaults () {
        this.refresh()
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/forms/interface.vue